import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_URL, SITE_NAME } from '../../constants/site';
import { buildOgImageUrl } from '../../constants/seo';
import { CONTACT_INFO } from '../../constants/contact';

/**
 * Site-wide SEO: Google Search Console verification and Organization/WebSite JSON-LD.
 */
export default function GlobalSeo() {
  const googleVerification = process.env.REACT_APP_GOOGLE_SITE_VERIFICATION?.trim();
  const siteUrl = SITE_URL.replace(/\/$/, '');

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: siteUrl,
    logo: buildOgImageUrl(),
    email: CONTACT_INFO.email,
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Discovery Bay',
      addressCountry: 'JM',
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: siteUrl,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteUrl}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <Helmet>
      {googleVerification && (
        <meta name="google-site-verification" content={googleVerification} />
      )}
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
    </Helmet>
  );
}
